document.addEventListener('click', function(e) {
  if (e.target && (e.target.id === 'mrv-launch' || e.target.closest('#mrv-launch'))) {
    e.preventDefault();
    if (window.mrvWidget && typeof window.mrvWidget.open === 'function') {
      window.mrvWidget.open();
    } else {
      // Fallback: try to wake the My Room Visualiser app bridge if installed
      window.dispatchEvent(new CustomEvent('mrv:launch', { detail: { source: 'pdp-cta' } }));
      // Inform shoppers if app is not yet installed
      console.warn('[MRV] My Room Visualiser widget not loaded yet.');
    }
  }
});
